import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { userActions } from "../../_actions";
import { Table } from "../../_components";
import { userConstants } from "../../_constants";
import { useModal } from "../../hooks/use-modal";
import { CopyDataModal } from "./components/copy-data-modal";
import "./css/hospitals.scss";
import activeIcon from "./img/active.webp";
import copyIcon from "./img/copy.webp";
import deactiveIcon from "./img/deactive.webp";
import usersIcon from "./img/masoleanjam.webp";

const formatData = (superHospitals, hospitals, onClick) => {
  return superHospitals.map((superHospital, index) => {
    const hospital = hospitals.find(({ id }) => id === superHospital.id);
    return [
      index + 1,
      <img
        className="hospital_icon"
        src={`${userConstants.SERVER_URL}${hospital?.logo?.url}`}
        alt=""
      />,
      superHospital?.name,
      superHospital?.id,
      <img
        className="status_icon"
        src={superHospital?.enabled ? activeIcon : deactiveIcon}
        alt=""
      />,
      <div className="modules_parent">
        <div
          className={`circle ${
            superHospital?.enabled ? "green_circle" : "red_circle"
          }`}
          data-tip="سنجاب"
        />
        <div
          className={`circle ${
            superHospital?.activate_crm ? "green_circle" : "red_circle"
          }`}
          data-tip="crm"
        />
        <div
          className={`circle ${
            superHospital?.active_edu ? "green_circle" : "red_circle"
          }`}
          data-tip="آموزش"
        />
        <div
          className={`circle ${
            superHospital?.activate_azmoon ? "green_circle" : "red_circle"
          }`}
          data-tip="آزمون"
        />
        <div
          className={`circle ${
            superHospital?.activate_portal ? "green_circle" : "red_circle"
          }`}
          data-tip="پورتال"
        />
        <ReactTooltip type="dark" />
      </div>,
      <div className="actions_parent">
        <img
          className="copy_icon"
          src={copyIcon}
          alt="کپی اطلاعات"
          onClick={() => onClick(superHospital?.id)}
        />
        <NavLink to={`superAdmin/users/${superHospital?.id}`}>
          <img className="user_icon" src={usersIcon} alt="لیست کاربران" />
        </NavLink>
      </div>,
    ];
  });
};

const Hospitals = () => {
  const dispatch = useDispatch();
  const globalStorage = useSelector((state) => state.globalStorage);

  const [isOpenCopyModal, openCopyModal, closeCopyModal] = useModal();
  const [activeHospitalId, setActiveHospitalId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(null);
  const [allHospitals, setAllHospitals] = useState([
    [
      { child: "ردیف" },
      { child: "لوگو" },
      { child: "نام بیمارستان" },
      { child: "شناسه بیمارستان" },
      { child: "وضعیت" },
      { child: "ماژول ها" },
      { child: "عملیـات" },
    ],
  ]);
  const [formValues, setFormValues] = useState({
    operationType: null,
    fromYear: null,
    toYear: null,
  });

  useEffect(() => {
    dispatch(userActions.API("get", `v1/hospitals`, null, true))
      .then((res) => {
        const hospitals = res.data;
        dispatch(
          userActions.API(
            "get",
            `v1/su_admin/all_hospitals?year=${globalStorage.year}`,
            null,
            true,
            false,
            JSON.parse(localStorage.getItem("tokenSuperAdmin"))
          )
        )
          .then((res) => {
            setAllHospitals((prevState) => [
              ...prevState,
              ...formatData(res.data, hospitals, onOpenCopyModal),
            ]);
          })
          .catch(() =>
            userActions.failure(userConstants.ERRORS["serverError"])
          );
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
    // eslint-disable-next-line
  }, [globalStorage.year]);

  const onChangeForm = (name, value) => {
    switch (name) {
      default:
        setFormValues({
          ...formValues,
          [name]: value,
        });
        break;
    }
  };

  const copyData = (type) => {
    const data = {
      hospital_id: activeHospitalId,
      from: formValues.fromYear,
      to: formValues.toYear,
    };

    dispatch(
      userActions.API(
        "post",
        `v1/su_admin/hospital/${type}/copy`,
        data,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    )
      .then(() => {
        reset();
        userActions.successToast("کپی اطلاعات با موفقیت انجام شد");
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]))
      .finally(() => setIsSubmitting(false));
  };

  const onPost = () => {
    dispatch(
      userActions.question("هشدار", "آیا از کپی اطلاعات اطمینان دارید؟")
    ).then((r) => {
      if (r.value) {
        copyData(formValues.operationType);
      }
    });
  };

  const reset = () => {
    closeCopyModal();
    setActiveHospitalId(null);
    setFormValues({
      operationType: null,
      fromYear: null,
      toYear: null,
    });
  };

  const onClose = () => {
    dispatch(
      userActions.question("انصراف", "آیا از انصراف اطمینان دارید؟")
    ).then((r) => {
      if (r.value) {
        reset();
      }
    });
  };

  const onOpenCopyModal = (id) => {
    openCopyModal();
    setActiveHospitalId(id);
  };

  return (
    <div className="hospitals">
      <Table
        headers={allHospitals[0]}
        data={allHospitals.length === 1 ? null : allHospitals.slice(1)}
      />
      {isOpenCopyModal && (
        <CopyDataModal
          onClose={onClose}
          formValues={formValues}
          onChangeForm={onChangeForm}
          isLoading={isSubmitting}
          submit={onPost}
        />
      )}
    </div>
  );
};

export default Hospitals;
